import { render, staticRenderFns } from "./BulkSetLelang.vue?vue&type=template&id=49de53e4&"
import script from "./BulkSetLelang.vue?vue&type=script&lang=js&"
export * from "./BulkSetLelang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports